import { defineStore } from 'pinia'
import { useCurrentUserStore } from './CurrentUserStore';
import { indexOf, isFunction, startCase } from 'lodash';
export const useTablePreferenceStore = defineStore('tablePreferenceStore', {
    state: () => (
        {
            preferences: {

            },
            columns: {

            },
            idents: [

            ],
            loading : false,
            changed : {

            },
            use : {

            },
        }),
    getters: {
        getColumnsForIdent: (state) => {
            return (ident) => {
                let index = -1;
                if(state.preferences[ident]){
                    index = state.preferences[ident].findIndex(item => item.id == state.use[ident]);
                }
                if(index > -1){
                    var tmp = [];
                    for(let i in state.preferences[ident][index].columns){
                        let columnindex = state.columns[ident].findIndex(item => item.id == state.preferences[ident][index].columns[i]?.id);
                        if(columnindex > -1){
                            tmp.push(
                                state.preferences[ident][index].columns[i]
                            );
                        }
                    }
                    return tmp;
                    // return state.columns[ident].filter((item) => state.preferences[ident][index].columns.includes(item.id));
                }else{
                    return state.columns[ident]
                }
            }
        },
        listPreferences : (state) => {
            return (ident) => {
                if(state.preferences && state.preferences[ident]){
                    return state.preferences[ident].filter(item => (item.id != "+" && item.id != 0));
                }
                return [];
            }
        }
    },
    actions: {
        clear(){
            this.preferences = {};
            this.columns = {};
            this.use = {};
            this.changed = {};
            this.idents = [];
        },
        array_move(arr, old_index, new_index) {
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing purposes
        },
        moveColumn(ident, column, direction){
            if(this.use[ident] == '0'){
                this.prepareChanges(ident);
            }
            var useIndex = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            var index = this.preferences[ident][useIndex].columns.findIndex(item => item.id == column.id);
            if(index >= 0){
                var moveTo = index + direction;
                if(moveTo >= this.preferences[ident][useIndex].columns.length){
                    moveTo = 0;
                }
                this.array_move(this.preferences[ident][useIndex].columns, index, moveTo);
                this.changed[ident] = true;
            }
        },
        updateSort(ident, except){
            if(this.use[ident] == '0'){
                this.prepareChanges(ident);
            }
            var useIndex = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            for(let i in this.preferences[ident][useIndex].columns){
                if(this.preferences[ident][useIndex].columns[i].key == except){
                    this.preferences[ident][useIndex].columns[i].direction_pos = 0;
                }else{
                    this.preferences[ident][useIndex].columns[i].direction_pos += 1;
                }
            }
        },
        addColumnPos(ident, position, column){
            if(this.use[ident] == '0'){
                this.prepareChanges(ident);
            }
            var useIndex = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            var index = this.preferences[ident][useIndex].columns.findIndex(item => item.id == column.id);
            if(index >= 0){

            }else{
                var addColIndex = this.columns[ident].findIndex(item => item.id == column.id);
                this.preferences[ident][useIndex].columns.splice(position, 0, this.columns[ident][addColIndex]);
            }
        },
        removeColumn(ident, column){
            let index = -1;
            if(this.use[ident] != 0){
                if(this.preferences[ident]){
                    index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
                }
            }
            if(index > -1){
                let colIndex = this.preferences[ident][index].columns.findIndex(item => item.id == column.id);
                if(colIndex > -1){
                    this.preferences[ident][index].columns.splice(colIndex, 1);
                }
            }
        },
        addColumn(ident, column_id){
            var current = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            if(current > -1){
                let colIndex = this.preferences[ident][current].columns.findIndex(item => item == column_id);
                if(colIndex > -1){
                    // this.preferences[ident][index].columns.splice(colIndex, 1);
                }else{
                    var addColIndex = this.columns[ident].findIndex(item => item.id == column_id);
                    this.preferences[ident][current].columns.push( this.columns[ident][addColIndex]);
                }
            }

        },
        prepareChanges(ident){
            let index = -1;
            if(this.preferences[ident]){
                index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            }
            if(index > -1){
                // TODO
            }else{
                var columns = [];
                for(let i in this.columns[ident]){
                    columns.push(this.columns[ident][i]);
                }
                this.preferences[ident].push({id : '+', name : "", global : "", columns: columns})
                this.use[ident] = "+";
            }
        },
        async tableIdent(ident){
            var index = this.idents.findIndex(item => item == ident);

            if(index > -1){
                return true;
            }else{
                this.use[ident] = 0;
                this.changed[ident] = false;
                this.idents.push(ident);
                await this.loadPreferences(ident);
            }
        },
        async loadPreferences(ident){
            const currentUser = useCurrentUserStore();
            this.loading = true

            return await axios.get("/api/v1/" + currentUser.internal_company + "/table_preferences/" + ident).then((response) => {
                this.loading = false;
                this.preferences[ident] = response.data.data;
                this.columns[ident] = response.data.meta.columns;
                this.loading = false;
                return response.data;
            });
        },
        async saveTablePreferences(ident, name){
            var index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            if(index > -1){
                var data = JSON.parse(JSON.stringify(this.preferences[ident][index]));
                if(this.use[ident] == "+" || this.use[ident] == 0){

                    this.store(data, ident);
                }else{
                    this.update(data, ident);
                }
            }

        },
        async updateCurrent(ident, name = ""){
            var index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            if(index > -1){
                var data = JSON.parse(JSON.stringify(this.preferences[ident][index]));
                if(name != ""){
                    data.name = name;
                }
                this.update(data, ident);
            }
        },
        async getId(id, ident){
            const currentUser = useCurrentUserStore();
            return await axios.get("/api/v1/" + currentUser.internal_company + "/table_preferences/id/" + id).then(response => {
                let index = this.preferences[ident].findIndex(item => item.id == response.data.data.id);
                if(index > -1){
                    this.preferences[ident][index] = response.data.data;
                }else{
                    this.preferences[ident].push(response.data.data);
                }
                return response.data;
            });
        },
        async saveNew(ident, name){
            var index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            var refresh_id = this.preferences[ident][index].id;
            if(index > -1){
                var data = JSON.parse(JSON.stringify(this.preferences[ident][index]));
                data.name = name;
                data.id = '+';
                await this.store(data, ident);

            }
            if(refresh_id > 0){
                this.getId(refresh_id, ident);
            }
        },

        async store(data, ident){
            const currentUser = useCurrentUserStore();
            return await axios.put("/api/v1/" + currentUser.internal_company + "/table_preferences/" + ident, data).then(response => {
                let index = this.preferences[ident].findIndex(item => item.id == response.data.data.id);
                if(index > -1){
                    this.preferences[ident][index] = response.data.data;
                }else{
                    this.preferences[ident].push(response.data.data);
                }
                this.use[ident] = response.data.data.id;
                this.changed[ident] = false;
                return response.data;
            });
        },
        async delete(ident){
            var index = this.preferences[ident].findIndex(item => item.id == this.use[ident]);
            if(index > -1 && this.preferences[ident][index].id){
                const currentUser = useCurrentUserStore();
                await axios.delete("/api/v1/" + currentUser.internal_company + "/table_preferences/" + ident + "/" +  this.preferences[ident][index].id).then(response => {
                    this.preferences[ident].splice(index, 1);
                    this.use[ident] = 0;
                    this.changed[ident] = false;
                    return response.data;
                })

            }
        },
        async update(data, ident) {
            const currentUser = useCurrentUserStore();
            await axios.post("/api/v1/" + currentUser.internal_company + "/table_preferences/" + ident + "/" + data.id, data).then(response => {

                let index = this.preferences[ident].findIndex(item => item.id == response.data.data.id);
                if(index > -1){
                    this.preferences[ident][index] = response.data.data;
                }else{
                    this.preferences[ident].push(response.data.data);
                }
                this.use[ident] = response.data.data.id;
                this.changed[ident] = false;

            })
        },
    },
  });
